import { RefreshCw } from 'lucide-react'
import { PageShell } from '@/components/common/PageShell'
import { WelcomeBanner, DashboardStats, DashboardCharts, RecentActivityTabs } from '@/components/dashboard'
import { Button } from '@/components/ui/button'
import { useDashboardData } from '@/api/dashboard'

/**
 * Dashboard page showing a welcome banner, stats grid, charts, and recent activity.
 * Route: /#/
 */
export function DashboardPage() {
  const { stats, charts, activity, isLoading, isFetching, error, refetch } = useDashboardData({
    refetchInterval: 30000, // 30 seconds
  })

  if (error) {
    return (
      <PageShell>
        <div className="p-6 space-y-6">
          Failed to load dashboard data. Please try again.
        </div>
      </PageShell>
    )
  }

  return (
    <PageShell>
      <div className="p-6 space-y-6">
        {/* Welcome Banner with quick actions */}
        <div className="flex items-center justify-between gap-4">
          <div className="flex-1">
            <WelcomeBanner
              activeRunCount={stats.activeRuns}
              activeSessionCount={stats.activeSessions}
            />
          </div>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => refetch()}
            disabled={isFetching}
            className="flex-shrink-0"
            title="Refresh dashboard"
          >
            <RefreshCw className={`h-4 w-4 ${isFetching ? 'animate-spin' : ''}`} />
          </Button>
        </div>

        {/* Statistics Cards — 4-column grid */}
        <DashboardStats stats={stats} isLoading={isLoading} />

        {/* Charts Section */}
        <DashboardCharts data={charts} isLoading={isLoading} />

        {/* Recent Activity Timeline */}
        <RecentActivityTabs data={activity} isLoading={isLoading} />
      </div>
    </PageShell>
  )
}

export default DashboardPage
